import { Component } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { AddToOrderViewModel } from '@order/models/add-to-order-view-model';
import { OrderService } from '@order/services/order.service';
import { Order } from '@usf/ngrx-order';
import { debounceTime, take } from 'rxjs/operators';

@Component({
  selector: 'app-existing-order-mobile',
  templateUrl: './existing-order-mobile.component.html',
  styleUrls: ['./existing-order-mobile.component.scss'],
})
export class ExistingOrderMobileComponent {
  vm: AddToOrderViewModel[];
  selectedOrderDetails: AddToOrderViewModel;
  data: any;

  constructor(
    private orderService: OrderService,
    public navParams: NavParams,
    private modalController: ModalController,
  ) {
    this.data = navParams?.get('data');
  }

  ionViewWillEnter(): void {
    this.orderService
      .loadAddToOrderViewModel$()
      .pipe(debounceTime(10), take(1))
      .subscribe(
        (addToOrderVM: AddToOrderViewModel[]) => (this.vm = addToOrderVM),
      );
  }

  onOrderSelected(selectedRadioItem: AddToOrderViewModel) {
    this.selectedOrderDetails = selectedRadioItem;
  }
  async onSubmit() {
    //Tab-2 submission
    //add new qty to existing order from radio list for the customer in context
    const selectedOrder: Order = {
      orderHeader: this.selectedOrderDetails?.orderHeader,
      orderItems: this.selectedOrderDetails.orderItems,
    };
    await this.orderService.makeOrderCurrentOrder(
      selectedOrder,
      this.selectedOrderDetails?.selectedOrderCustomer,
    );

    const updateExistingOrder = {
      // currentTab: currentTab,
      orderHeader: selectedOrder?.orderHeader,
      origOrderItems: selectedOrder?.orderItems,
      updateOrderItem: this.data?.updateOrderItem, //new incoming qty for a product
    };

    this.orderService.submitAddToOrderModal(updateExistingOrder);
  }

  async closeModal() {
    const modData = {
      orderHeader: this.selectedOrderDetails?.orderHeader,
      origOrderItems: this.selectedOrderDetails?.orderItems,
      updateOrderItem: this.data?.updateOrderItem,
    };
    this.orderService.cancelAddToOrderModal(modData);
    await this.modalController.dismiss();
  }

  trackItem(index: any, item: any) {
    return item ? index : undefined;
  }
}
